<template>
  <div id="supplements">

    <Datatable
      entity="tax"
      ref="datatable"
      :globalActions="[{text: 'tax.new', method: onCreate}]"
      :rowActions="[{text: 'datatable.edit', method: onRowEdit}, {text: 'datatable.delete', method: onRowDelete}]"
      :onRowClick="onRowEdit">
    </Datatable>
  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import { mapActions } from 'vuex';

  export default {

    name: "taxes",

    components: { Datatable },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "taxes.title";
      this.$store.state.pageIcon = "";
    },

    methods: {
      ...mapActions(['deleteTax']),

      onCreate() {
        this.$router.push(this.$router.buildContext("/tax"));
      },
      onRowEdit(row) {
        this.$router.push(this.$router.buildContext("/tax", {id: row.id}));
      },
      async onRowDelete(row) {
        await this.deleteTax({taxId: row.id});
        this.$refs.datatable.query();
      }
    }
  }

</script>

<style lang="scss" scoped>

  .datatable {
    height: 100%;
  }

</style>
